import { Link } from 'react-router-dom';
import { games } from '@/mocks/games';

const popularGames = games.slice(0, 8);

const categoryColorMap: Record<string, string> = {
  casual: 'bg-green-100 text-green-600',
  rpg: 'bg-red-100 text-red-600',
  strategy: 'bg-amber-100 text-amber-600',
  board: 'bg-teal-100 text-teal-600',
  sports: 'bg-orange-100 text-orange-600',
};

const categoryNameMap: Record<string, string> = {
  casual: '休闲益智',
  rpg: '角色扮演',
  strategy: '策略竞技',
  board: '棋牌游戏',
  sports: '体育竞速',
};

const gameImages: Record<string, string> = {
  'ng-lucky-wheel': 'https://readdy.ai/api/search-image?query=Mobile%20game%20lucky%20wheel%20casino%20style%20banner%20with%20gold%20and%20emerald%20green%20lighting%2C%20dark%20luxurious%20atmosphere%2C%20Chinese%20gaming%20aesthetic%2C%20soft%20glow%20effects%2C%20minimalist&width=600&height=400&seq=game-lucky-wheel&orientation=landscape',
  'ng-legend-sword': 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20RPG%20game%20banner%20with%20sword%20and%20magic%20effects%2C%20dark%20dramatic%20atmosphere%2C%20emerald%20green%20and%20gold%20accents%2C%20Chinese%20fantasy%20style%2C%20cinematic%20lighting&width=600&height=400&seq=game-legend-sword&orientation=landscape',
  'ng-chess-empire': 'https://readdy.ai/api/search-image?query=Luxurious%20card%20game%20banner%20with%20playing%20cards%20and%20gold%20coins%2C%20dark%20elegant%20atmosphere%2C%20emerald%20green%20felt%20table%2C%20Chinese%20gaming%20club%20vibe%2C%20warm%20lighting&width=600&height=400&seq=game-chess-empire&orientation=landscape',
  'ng-strategy-kingdom': 'https://readdy.ai/api/search-image?query=Strategy%20war%20game%20banner%20with%20kingdom%20and%20army%2C%20dark%20epic%20atmosphere%2C%20gold%20and%20emerald%20accents%2C%20Chinese%20ancient%20war%20style%2C%20dramatic%20lighting&width=600&height=400&seq=game-strategy-kingdom&orientation=landscape',
  'ng-speed-racer': 'https://readdy.ai/api/search-image?query=Racing%20game%20banner%20with%20sports%20car%20and%20neon%20lights%2C%20dark%20night%20city%20atmosphere%2C%20emerald%20green%20and%20gold%20accents%2C%20speed%20motion%20blur%2C%20cinematic&width=600&height=400&seq=game-speed-racer&orientation=landscape',
  'ng-fish-joy': 'https://readdy.ai/api/search-image?query=Underwater%20fishing%20game%20banner%20with%20colorful%20fish%20and%20bubbles%2C%20deep%20ocean%20dark%20atmosphere%2C%20emerald%20green%20and%20gold%20light%20rays%2C%20casual%20gaming%20vibe&width=600&height=400&seq=game-fish-joy&orientation=landscape',
  'ng-dark-dungeon': 'https://readdy.ai/api/search-image?query=Dark%20dungeon%20RPG%20game%20banner%20with%20torch%20light%20and%20ancient%20ruins%2C%20mysterious%20atmosphere%2C%20emerald%20green%20glow%20and%20gold%20treasure%2C%20fantasy%20style%2C%20cinematic&width=600&height=400&seq=game-dark-dungeon&orientation=landscape',
  'ng-poker-tournament': 'https://readdy.ai/api/search-image?query=Poker%20tournament%20game%20banner%20with%20chips%20and%20cards%2C%20dark%20elegant%20casino%20atmosphere%2C%20emerald%20green%20table%20and%20gold%20accents%2C%20luxurious%20gaming%20club%2C%20warm%20spotlight&width=600&height=400&seq=game-poker-tournament&orientation=landscape',
};

export default function PopularGamesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              热门游戏推荐
            </h2>
            <p className="text-sm text-foreground-500">精选南宫平台最受欢迎的游戏，一键下载畅玩</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop="true">
          {popularGames.map((game) => (
            <article
              key={game.id}
              className="group rounded-lg bg-background-100 overflow-hidden hover:bg-background-200/70 transition-colors duration-200 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={gameImages[game.id] || gameImages['ng-lucky-wheel']}
                  alt={game.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2 py-0.5 rounded text-xs font-medium ${categoryColorMap[game.category] || 'bg-gray-100 text-gray-600'}`}>
                    {categoryNameMap[game.category] || game.category}
                  </span>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-1 bg-black/60 backdrop-blur-sm rounded-full px-2 py-0.5">
                  <i className="ri-star-fill text-accent-400 text-xs"></i>
                  <span className="text-white text-xs font-medium">{game.rating}</span>
                </div>
              </div>

              <div className="p-4">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 flex-shrink-0">
                    <i className={`${game.icon} text-base`}></i>
                  </div>
                  <div className="min-w-0">
                    <h3 className="font-heading text-sm text-foreground-900 truncate">{game.name}</h3>
                    <p className="text-xs text-foreground-400 mt-0.5">{game.size} · 下载 {game.downloads}</p>
                  </div>
                </div>

                <div className="flex items-center gap-2 mt-3">
                  {game.platforms.includes('iOS') && (
                    <span className="text-xs text-foreground-400 flex items-center gap-1">
                      <i className="ri-apple-fill text-xs"></i> iOS
                    </span>
                  )}
                  {game.platforms.includes('Android') && (
                    <span className="text-xs text-foreground-400 flex items-center gap-1">
                      <i className="ri-android-fill text-xs"></i> Android
                    </span>
                  )}
                  {game.platforms.includes('PC') && (
                    <span className="text-xs text-foreground-400 flex items-center gap-1">
                      <i className="ri-computer-line text-xs"></i> PC
                    </span>
                  )}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部游戏 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}